<template lang="pug">
  component(:is="responsiveQuestionContainer")
    //- Desktop
    .flex.flex-wrap.pb-20.relative.h-full(v-if="!isMobile")
      div(:class='guidePathClasses')
      profiling-guide(:content="escortMessage" :status="status" class='w-1/12')
      .pr-8.pl-2(class='w-6/12 lg:pl-0')
        b.text-lg.text-gray-900(class='md:text-xl' v-html="question")
        p.text-sm(v-html="description")
        slot(name='loading-element')
      div(class='w-5/12')
        slot(:go-to-next-question="goToNextQuestion" :auto-open-next-select="autoOpenNextSelect")
    //- Mobile
    .flex.flex-col.pb-20(v-else)
      .w-full.pt-2.pl-2
        .pr-8
          b.text-lg.leading-tight.text-gray-900(v-html="question")
      div(v-if="escortMessage" :class="{ 'order-last': escortUnderInputsOnMobile }")
        sw-speech-balloon.mt-6.pt-2(
          image-path='shared/hugues.jpg'
          top-margin="-mt-18"
        )
          p(v-html="escortMessage")
      div(v-if="description" :class="{ 'order-last': descriptionUnderInputsOnMobile }")
        p.text-sm.italic.w-full.px-2.py-1(v-html="description")
        slot(name='loading-element')
      .w-full
        slot(:go-to-next-question="goToNextQuestion" :auto-open-next-select="autoOpenNextSelect")
</template>

<script>
import { SwiperSlide } from 'vue-awesome-swiper';
import { responsiveWatcher } from '../../mixins/responsiveWatcher';
import { smoothScroller } from '../../mixins/smoothScroller';
import ProfilingGuide from './ProfilingGuide';

export default {
  name: 'ProfilingQuestion',
  components: {
    SwiperSlide,
    ProfilingGuide,
    SwSpeechBalloon: () => import('./SwSpeechBalloon'),
  },
  mixins: [responsiveWatcher, smoothScroller],
  props: {
    question: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    descriptionUnderInputsOnMobile: {
      type: Boolean,
      default: false,
    },
    escortMessage: {
      type: String,
      default: '',
    },
    escortUnderInputsOnMobile: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      swipingOngoing: false,
    };
  },
  computed: {
    responsiveQuestionContainer () {
      return this.isMobile ? 'swiper-slide' : 'div';
    },
    guidePathClasses () {
      return 'absolute top-0 left-0 h-full border-blue-500 border-l-2 ml-6 mt-6';
    },
  },
  methods: {
    autoOpenNextSelect () {
      setTimeout(() => {
        const firstUnansweredProfilingSelect = this.$children.filter(el => el.$options._componentTag == 'profiling-select' && el._props.value == null)[0];
        if (!firstUnansweredProfilingSelect) return this.$emit('blur');

        const swSelect = firstUnansweredProfilingSelect.$children[0];
        swSelect.open();
        swSelect.$refs.menu.focus();
      }, 350);
    },
    goToNextQuestion () {
      const delayTime = 400;

      this.$nextTick(() => {
        if (this.status !== 'success') return;

        if (!this.isMobile) {
          const elementToScrollTo = document.getElementById(this.$attrs.id).nextElementSibling;
          const offset = 250;
          this.smoothScrollToElement(elementToScrollTo, offset, delayTime);
        } else if (!this.swipingOngoing) {
          this.swipingOngoing = true;
          setTimeout(() => {
            this.$emit('autoswipe');
            this.swipingOngoing = false;
          }, delayTime);
        }
      });
    },
  },
};
</script>
